module.exports = __webpack_public_path__ + "static/Made_Evolve_Sans_Light-c43878c5ebf1c6424412a9f9c1009411.woff";